import { RecommendationsHit } from 'algoliasearch'
import { getFeature } from '@/data/api/feature'
import client from '.'
import { SoundIndex, UserIndex } from '@/interfaces/algolia'

// レコメンデーションクライアントの初期化
const recommendClient = client.initRecommend()

// MediaのTrending Itemsのレコメンデーション取得関数
export const getRecommendedTrendingMedia = async ({
  limit = 10,
  userId,
}: {
  limit?: number,
  userId?: string,
}): Promise<(RecommendationsHit & SoundIndex)[]> => {
  try {
    const { results } = await recommendClient.getRecommendations({
      requests: [{
        indexName: 'media',
        model: 'trending-items',
        threshold: 0,
        maxRecommendations: limit,
        queryParameters: {
          userToken: userId && `user-${userId}`,
        },
      }],
    })
    
    const hits = results[0]?.hits || []
    return hits
  }
  catch (error) {
    console.error('Error fetching trending recommendations:', error)
    return null
  }
}

// UserのTrending Itemsのレコメンデーション取得関数
export const getRecommendedTrendingUser = async ({
  limit = 10,
  userId,
}: {
  limit?: number,
  userId?: string,
}): Promise<(RecommendationsHit & UserIndex)[]> => {
  try {
    const { results } = await recommendClient.getRecommendations({
      requests: [{
        indexName: 'users',
        model: 'trending-items',
        threshold: 0,
        maxRecommendations: limit,
        queryParameters: {
          userToken: userId && `user-${userId}`,
        },
      }],
    })
    const hits = results[0]?.hits || []
    return hits
  }
  catch (error) {
    console.error('Error fetching trending recommendations:', error)
    return null
  }
}

// MediaのLooking Similarのレコメンデーション取得関数
export const getRecommendedSimilarMedia = async ({
  soundId,
  limit = 10,
  userId,
}: {
  soundId: string,
  limit?: number,
  userId?: string,
}): Promise<(RecommendationsHit & SoundIndex)[]> => {
  try {
    const { results } = await recommendClient.getRecommendations({
      requests: [{
        indexName: 'media',
        model: 'looking-similar',
        threshold: 0,
        maxRecommendations: limit,
        objectID: `sound-${soundId}`,
        queryParameters: {
          userToken: userId && `user-${userId}`,
        },
      }],
    })

    const hits = results[0]?.hits || []
    return hits
  }
  catch (error) {
    console.error('Error fetching similar recommendations:', error)
    return []
  }
}

// UserのLooking Similarのレコメンデーション取得関数
export const getRecommendedSimilarUser = async ({
  similarUserId,
  limit = 10,
  userId,
}: {
  similarUserId: string,
  limit?: number,
  userId?: string,
}): Promise<(RecommendationsHit & UserIndex)[]> => {
  try {
    const { results } = await recommendClient.getRecommendations({
      requests: [{
        indexName: 'users',
        model: 'looking-similar',
        threshold: 0,
        maxRecommendations: limit,
        objectID: `user-${similarUserId}`,
        queryParameters: {
          userToken: userId && `user-${userId}`,
        },
      }],
    })

    const hits = results[0]?.hits || []
    return hits
  }
  catch (error) {
    console.error('Error fetching similar recommendations:', error)
    return []
  }
}

export const getFeatureSound = async (limit = 10): Promise<SoundIndex[]> => {
  // const result = await getRecommendedTrendingMedia({ limit })
  // if (result) {
  //   return result
  // }
  // Algoliaのconversionの準備ができるまではAPIから取得する
  const featured = await getFeature('Sound', limit)
  if (featured) {
    return featured.map((res) => ({
      ...res.sound,
      mediaType: 'sound',
      objectID: `sound-${res.sound.id}`,
      // _tags: res.sound.tags,
    }))
  }
  return []
}

export const getFeatureUser = async (limit = 12): Promise<UserIndex[]> => {
  // const result = await getRecommendedTrendingUser({ limit })
  // if (result) {
  //   return result
  // }
  // Algoliaのconversionの準備ができるまではAPIから取得する
  const featured = await getFeature('User', limit)
  if (featured) {
    return featured.map((res) => ({
      ...res.user,
      mediaType: 'user',
      objectID: `user-${res.user.id}`,
      // _tags: res.user.tags,
    }))
  }
  return []
}

